import { Ortak } from './../../../../providers/ortak';
import { Component } from '@angular/core';
import {  NavController, NavParams, ViewController } from 'ionic-angular';
import { BllOrtak } from '../../../../providers/bll/bll-ortak';

/**
 * Generated class for the BankaEkleGuncellePage page.
 *
 * See https://ionicframework.com/docs/components/#navigation for more info on
 * Ionic pages and navigation.
 */


@Component({
  selector: 'page-banka-ekle-guncelle',
  templateUrl: 'banka-ekle-guncelle.html',
})
export class BankaEkleGuncellePage {
  banka:any={ID:-1};
  BankaVw:any={};

  constructor(public navCtrl: NavController,
    public ortak:Ortak,
    public bllOrtak:BllOrtak,
    public viewCtrl:ViewController,
     public navParams: NavParams) {
      if (navParams.get("BankaVw") != null) {
        this.BankaVw = navParams.get("BankaVw");
        var data = new FormData();
        data.append("Banka_id", this.BankaVw.ID);
        this.bllOrtak.islem(data, "BankaGetirByID", "", false).then(a => {
          var Sonuc = <any>a;
          this.banka = Sonuc.SonucObject;
          
        }
        )
      }
  }

  ionViewDidLoad() {

  }
  boslukKontrol() {
    var mesaj = "";
    
    if (this.banka.Name == null || this.banka.Name == "") {
      mesaj = mesaj + "Lütfen Banka adını giriniz. <br/>";
    }

    if (mesaj == "") {
      return true;
    }
    else {
      this.ortak.showBasicAlert("Uyarı", mesaj);
      return false;
    }
  }
  kaydet() {

    var formData = new FormData();
   
    if (this.boslukKontrol()) {
      formData.append("Banka_json", JSON.stringify(this.banka));
     
      this.bllOrtak.islem(formData, "BankaEkleGuncelle", "", true).then(a => {
        var sonuc = <any>a;
        if(sonuc.Sonuc==1) this.ortak.showBasicAlert("Başarılı","İşlem Başarılı");
       

      })
    }
    this.cikis();
    }
    cikis()
    {
      this.viewCtrl.dismiss();
    }

}



// WEBPACK FOOTER //
// ./src/pages/Yonetim/BankaIslemleri/banka-ekle-guncelle/banka-ekle-guncelle.ts